import React from 'react';
import {BooleanField, ChipField, Datagrid, DateField, List, TextField} from 'react-admin';
import {FilmOnVodUrlField} from "../components/my-url-field";
import {MovieFilter} from "../filters/movie-filter";
import {MovieActions} from "../list-actions/movie-actions";

export const MovieList = props => (
    <List {...props} filters={<MovieFilter />} perPage={50} bulkActionButtons={<MovieActions />}>
        <Datagrid rowClick="edit">
            <TextField source="id" sortable={true}/>
            <TextField source="title" sortable={false} />
            <FilmOnVodUrlField
                source="slug"
                urlFactory={(movie) => `https://www.filmon.com/vod/view/${movie.slug}`}
                sortable={false}
            />

            <TextField source="original_id" sortable={false}/>
            <TextField source="vendorka_id" sortable={false}/>

            <BooleanField source="deleted" sortable={false} label="Archived(removed)" />
            <BooleanField source="is_enabled" sortable={false}/>
            <BooleanField source="is_featured" sortable={false}/>
            <BooleanField source="audioOnly" sortable={false}/>

            <GenresList label="genres" source="genres" sortable={false}/>

            <DateField source="createdAt" sortable={true}/>
            <DateField source="updatedAt" sortable={true}/>
        </Datagrid>
    </List>
);

const GenresList = ( {record} ) => {
    return record.genres && record.genres.length > 0 ? (
        <React.Fragment>
            {record.genres.map(item => (
                <ChipField key={item} record={{name: item}} source="name"/>
            ))}
        </React.Fragment>
    ) : null;
};
/*

const ImageSchema = mongoose.Schema({
    width: {type: Number, required: true},
    height: {type: Number, required: true},
    url: {type: String, required: true},
    alt: {type: String},
    copyright: {type: String},
    type: {type: String},
});

const VideoGenreSchema = mongoose.Schema({
    genre_id: { type: Number, required: true }, // original_id
    slug: { type: String, required: true },
    name: { type: String, required: true },
});


const CastSchema = mongoose.Schema({ // reduced cast schema with linked person
    character: String,
    person: { fullname: String},
});

const CrewSchema = mongoose.Schema({ //reduced crew schema with linked person
    crew: String,
    person: { fullname: String},
});


const PersonSchema = mongoose.Schema({ // unused here
    fullname: { type: String, required: true},
    slug: { type: String, required: true},
    bio: { type: String, required: true},
});


const VideoSchema = mongoose.Schema({
    title: { type: String, required: true}, // search index
    slug: {
        type: String, required: true, index: true, unique: true, lowercase: true,
        slug: ['original_id', 'title']
    },


    description: String,

    genres: { type: [String] }, // Array of genre slugs. Client responsible to resolve genre title by making /genres request + local translation

    keywords: { type: [String]},
    tags: { type: [String]},

    featured: { type: Boolean, default: false}, // partial index here
    is_enabled: { type: Boolean, default: false}, // partial index

    length: {type: Number},

    createdAt : { type: Date, default: Date.now },
    updatedAt : { type: Date, default: Date.now },
    deletedAt : { type: Date, default: null},
    deleted: { type: Boolean, default: false }, // partial index

    // legacy identifiers
    original_id: { type: Number },
    vendorka_id: { type: Number },
    vendor_id: { type: Number },

    // type identifiers (hate this shit)
    audioOnly: { type: Boolean, default: false, alias: 'is_vox'},

    // episode aggregates:
    is_episode: { type: Boolean, default: false},
    episode_number: { type: Number, default: 0},
    series_number: { type: Number, default: 0 },

    // geo restrictions
    restrict_to_countries: {type: [String], default: null},

    poster: ImageSchema,
    artwork: [ImageSchema],

    crew: [CrewSchema],
    cast: [CastSchema],

    public_url: {type: String},
});

VideoSchema.virtual('is_vod').get( function() {
    return this.audioOnly !== true;
}).set(function(value) {
    this.audioOnly = !value;
    return this;
});

module.exports = mongoose.model('video', VideoSchema); // no linked collections for performance

 */
